import { useQuery } from "@tanstack/react-query";
import { getClients } from "../../api/apiClients";
import i18next from "i18next";

/**
 * Hook لجلب قائمة العملاء المفلترة
 * @param {Object} params - Query parameters (page, per_page, search, trashed)
 */
export function useGetClients(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["clients", params, i18next.language],
        queryFn: () => getClients(params),
        retry: false,
    });

    const clients = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, clients, meta, refetch };
}